exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.wrapper[data-v-7fad2d32] {\n  display: block;\n  height: 2rem;\n}\n.text-char-counter[data-v-7fad2d32] {\n  font-size: 0.95rem;\n}\n.text-char-counter.error[data-v-7fad2d32] {\n  color: #800;\n}\n.arc-indicator[data-v-7fad2d32] {\n  vertical-align: middle;\n  float: left;\n  margin: 2px;\n  width: 16px;\n  height: 16px;\n}\n", ""]);

